export var DatoSupportModelApiKey;
(function (DatoSupportModelApiKey) {
    DatoSupportModelApiKey["SHARED_SUPPORT_OPENING_TIME"] = "shared_support_opening_time";
    DatoSupportModelApiKey["SHARED_SUPPORT_SPECIAL_OPENING_TIME"] = "shared_support_special_opening_time";
    DatoSupportModelApiKey["SHARED_SUPPORT_OPENING_TIME_OPEN24H"] = "shared_support_opening_time_open24h";
    DatoSupportModelApiKey["SHARED_SUPPORT_SPECIAL_OPENING_TIME_OPEN24H"] = "shared_support_special_opening_time_open24h";
})(DatoSupportModelApiKey || (DatoSupportModelApiKey = {}));
